<template>
    <div class="home_container">
        <div class="home_head_block">
            <div class="home_head_top">
                <div class="head_top_left" @click="changeLanguage(true)">{{local == 'zh' ? '中文' : 'EN'}}</div>
            </div>
            <div class="home_head_bottom">
                <div class="head_bottom_item" @click="toWebs(1)">{{$t('jbjlbz')}}</div>
                <div class="head_bottom_item" @click="toWebs(2)">{{$t('jbfscx')}}</div>
                <div class="head_bottom_item" @click="openRedLine">{{$t('hxqd')}}</div>
            </div>
        </div>

        <div class="home_content_block">
            <div class="home_content_grid">
                <div class="content_grid_row">
                    <div class="grid_row_item" @click="openJbts">
                        <div class="row_item_bg">
                            <img :src="jbtsUrl" alt="" class="row_item_icon">
                        </div>
                        <span class="row_item_text">{{$t('jbts')}}</span>
                    </div>
                    <div class="grid_row_split"></div>
                    <div class="grid_row_item" @click="openLjrz">
                        <div class="row_item_bg">
                            <img :src="ljrzUrl" alt="" class="row_item_icon">
                        </div>
                        <span class="row_item_text">{{$t('ljrz')}}</span>
                    </div>
                </div>

                <div class="content_grid_row" style="margin-top: 10px;">
                    <div class="grid_row_item" @click="openLjsj">
                        <div class="row_item_bg">
                            <img :src="ljsjUrl" alt="" class="row_item_icon">
                        </div>
                        <span class="row_item_text">{{$t('ljsj')}}</span>
                    </div>
                    <div class="grid_row_split"></div>
                    <div class="grid_row_item" @click="openLict">
                        <div class="row_item_bg">
                            <img :src="lyctUrl" alt="" class="row_item_icon">
                        </div>
                        <span class="row_item_text">{{$t('lyct')}}</span>
                    </div>
                </div>
            </div>
						<div class="bz_img_bz">
							<img src="@/assets/img/jbcx.jpg" alt="" class="bz_img">
						</div>
            <!-- <div class="home_content_box">
                <div class="content_box_row" v-for="(item, index) in datas" :key="index" @click="toDialog(item.guid)">
                    <span class="row_left_date">{{ item.createdStr }}</span>
                    <span class="row_left_title">{{ item.title }}</span>
                    <div class="box_row_block">
                        <div class="row_block_left">{{ item.content }}</div>
                        <img :src="Cookie.get('apiUrl')+'/api/openApi/store/v0.1/read/'+item.imgs.split(',')[0]" alt="" v-if="item.imgs" class="row_right_img">
                    </div> -->
                    <!-- <span class="row_left_date" style="margin-top: 10px;">阅读：{{ item.readNum }}</span> -->
                <!-- </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant-green'
export default {
    data(){
        return{
            loading:false,
            datas:[],
            // jbtsUrl:require('../../assets/img/jbts.png'),
            // ljrzUrl:require('../../assets/img/ljrz.png'),
            // ljsjUrl:require('../../assets/img/ljsj.png'),
						// lyctUrl:require('../../assets/img/lyct.png'),
						
            jbtsUrl:require('../../assets/img/jbts.png'),
            ljrzUrl:require('../../assets/img/ljrz.png'),
            ljsjUrl:require('../../assets/img/ljsj.png'),
            lyctUrl:require('../../assets/img/lyct.png'),
						local:'',
						isZh:true
        }
    },

    created(){
        // let lang = localStorage.getItem('lang')
        let lang = this.i18n.locale
        console.log(lang)
        if(lang == 'zh'){
            this.local = 'en'
        }else{
            this.local = 'zh'
				}
				this.isZh = lang == 'zh'
				// if(lang != 'en'){
				// 	Object.keys(this.$ens).forEach(item=>{
				// 		this.$ens[item] = item
				// 	})
				// }
    },

    mounted(){
				document.title=this.$t('ljsy')
				if(this.isZh){
					this.getDataList()
				}
    },
    methods:{
        getDataList(){
            this.$http.get('/api/ts/v0.1/article/getAllDatas')
            .then(res=>{
                console.log(res)
                if(res.status==200){
                    this.datas = res.data
                }else{
                    this.$message.error('查询失败！请联系管理员')
                }
                setTimeout(()=>{
                    this.loading=false;
                },800)
            })
            .catch((err)=>{
                this.loading=false;
            })
        },
        toDialog(guid){
            this.$router.push({
                name: "noticeDetail",
                query: {
                    guid:guid
                }
            });
        },
        toWebs(type){
            this.$router.push({
                name: "webs",
                query: {
                    type:type
                }
            });
        },
        //红线清单
        openRedLine(){
            this.$router.push({
                name: "redline",
            });
        },
        changeLanguage(click){
            let lang = this.i18n.locale
            console.log(lang)
            this.local = lang
            if(lang=='en'){
                lang = 'zh'
            }else{
                lang = 'en'
						}
						
						
            // localStorage.setItem('lang',lang)
            // this.i18n.locale=lang
            // this.$emit('reloadBar')

            this.$changeLocales(lang)

						document.title=this.$t('ljsy')
						Toast.loading({
							message:lang=='en'?'Loading...........':'加载中。。。',
							forbidClick:true,
							overlay:true,
							duration:30000
						})
						if(click){
							window.location.reload()
						}
        },

        //举报投诉
        openJbts(){
            this.$router.push({
                name: "complaint",
            });
        },

        //廉洁认证
        openLjrz(){
            this.$router.push({
                name: "auth",
            });
        },

        //廉洁上缴
        openLjsj(){
            this.$router.push({
                name: "cashGift",
            });
        },

        //利益冲突
        openLict(){
            let pathName = ''
            console.log(this.local)
            if(this.local == 'en'){
                pathName = 'interest'
            }else{
                // pathName = 'interest_en'
                pathName = 'interest'
            }

            this.$router.push({
                name: pathName,
            });
        },
    }
}
</script>
<style scoped>
   .home_container{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
   }
   .home_head_block{
        width: 100%;
        height: 70px;
        background-color: white;
        position: absolute;
        left: 0;
        top: 0;
   }
   .home_head_top{
        width: 100%;
        height: 34px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
   }
   .head_top_left{
        width: 50px;
        height: 34px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #2d2dfd;
        font-weight: 700;
				cursor:pointer;
   }
   .home_head_bottom{
        width: 100%;
        height: 36px;
        display: flex;
        flex-direction: row;
        align-items: center;
   }
   .head_bottom_item{
        flex: 1;
        height: 36px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #44baff;
				cursor:pointer;
   }
   .home_content_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 80px;
        bottom: 0;
   }
   .home_content_grid{
        width: calc(100% - 20px);
        height: 210px;
        position: absolute;
				padding: 0px 10px;
        top: 0;
				overflow-y:scroll;
				padding-right: 100px;
   }
   .content_grid_row{
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: row;
				max-width: 960px;
				margin: 0 auto;
   }
   .grid_row_item{
        flex: 1;
        height: 100px;
        background-color: white;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
				cursor:pointer;
   }
   .grid_row_split{
        width: 10px;
        height: 100px;
   }
   .row_item_bg{
        width: 54px;
        height: 54px;
        border-radius: 20%;
        display: flex;
				/* background-color: rgb(230,240,253); */
				background-image: linear-gradient(180deg, rgb(230,240,253) 10%, rgba(230,240,253,0.5) 100%);
        flex-direction: row;
        justify-content: center;
        align-items: center;
   }
   .row_item_icon{
        width: 30px;
        height: 30px;
        display: block;
   }
   .row_item_text{
        display: block;
        font-size: 16px;
        color: #666;
        margin-top: 5px;
   }
   .home_content_box{
        width: 100%;
        position: absolute;
        left: 0;
        top: 220px;
        bottom: 0;
        overflow-y: scroll;
   }
   .content_box_row{
        width: 96%;
        height: auto;
        background-color: white;
        border-radius: 6px;
        margin-left: 2%;
        margin-bottom: 10px;
        padding: 10px;
        box-sizing: border-box;
				cursor:pointer;
   }
   .row_left_date{
        display: block;
        font-size: 14px;
        color: #666;
        text-align: left;
   }
   .row_left_title{
        display: block;
        font-size: 16px;
        color: #333;
        font-weight: 700;
        text-align: left;
        margin-top: 10px;
   }
   .box_row_block{
        width: 100%;
        height: auto;
        margin-top: 10px;
        display: flex;
        flex-direction: row;
   }
   .row_block_left{
        flex: 1;
        height: auto;
        margin-right: 10px;
        font-size: 16px;
        color: #666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        text-align: left;
   }
   .row_right_img{
        width: 80px;
        height: 80px;
        display: block;
   }
	 .bz_img_bz{
		 width: calc( 100% - 20px );
			position: absolute;
			left: 0;
			top: 210px;
			bottom: 0;
			overflow: overlay;
			padding:0px 10px 10px 10px;
			margin-top: 10px;
	 }
  .bz_img{
    width: 100%;
    height: auto;
		display: block;
		max-width: 960px;
		margin: 0px auto;
  }
</style>